import { Utils } from "./../../../utils/utils";
import {
	Component,
	ElementRef,
	HostListener,
	OnInit,
	OnDestroy,
	Optional,
	ViewEncapsulation,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "src/app/core/models/users/user.models";
import { LoginService } from "src/app/core/services/login";
import { UserDataGeneralComponent } from "src/app/pages/user-data/user-data-general/user-data-general.component";
import { ImagenPipe } from "src/app/shared/pipes/imagen.pipe";
import { MODAL_DIALOG_TYPES } from "src/app/core/utils/modal-dialog-types";
import { UsersService } from "src/app/core/services/users";
import { Profiles } from "src/app/core/utils/profiles.enum";
import { take, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { ModalProfileActionsComponent } from "src/app/shared/components/modal-profile-actions/modal-profile-actions.component";
import { Store } from "@ngrx/store";
import { State } from "src/app/store/models/store.model";
import { availableProfiles } from "src/app/store/models/profiles.model";
import { MeetingsComponent } from "src/app/pages/meetings/meetings.component";
import { LocalStorage } from "src/app/core/utils";
import { MastersService } from "src/app/core/services/masters";
import { ControlPanelComponent } from '../../../../shared/components/control-panel/control-panel.component';
import { ControlPanelPadresComponent } from '../../../../shared/components/control-panel-padres/control-panel-padres.component';
import {
	NbWindowRef
} from "@nebular/theme";
import { ChatAssistantComponent } from "src/app/shared/components/chat-assistant/chat-assistant.component";
import { ControlPanelAdminComponent } from "src/app/shared/components/control-panel-admin/control-panel-admin.component";
import { ControlPanelComercialComponent } from "src/app/shared/components/control-panel-comercial/control-panel-comercial.component";
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { ModalFirstStepStudentComponent } from "src/app/shared/components/modal-profile-actions/modal-first-step-student/modal-first-step-student.component";
import { TutorialModalService } from "src/app/core/services/shared/tutorial.modal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalGruposEditarComponent } from "src/app/shared/components/modal-grupos-editar/modal-grupos-editar.component";
const NOIMAGE = "../../../../../assets/images/icons/account_circle.svg";

@Component({
	selector: "app-user-account",
	templateUrl: "./user-account.component.html",
	styleUrls: ["./user-account.component.scss"],
	providers: [ImagenPipe],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class UserAccountComponent implements OnInit, OnDestroy {
	showUserAccount: boolean = false;
	user: User;
	profiles = Profiles;
	inside: boolean;
	actualProfile: string;
	userSelectedProfile: string;
	private destroy$ = new Subject();
	private profileLifetime$ = new Subject<void>();
	profilesOfUser: availableProfiles;
	comeFromProfile: string;
	tutorialesActivos: boolean = false;
	private pendingLastActivityProfile: string | null = null;
	private pendingLastActivityJustLoggedIn: boolean = false;

	enClase: boolean = false;
	isMobile: boolean = true;
	selectedGroupInfo: any;

	@HostListener("document:mousedown", ["$event"])
	onGlobalClick(event): void {
		if (!this.eRef.nativeElement.contains(event.target)) {
			this.showUserAccount = false;
		}
	}

	@HostListener("document:keydown", ["$event"])
	onSpacebarToggle(event: KeyboardEvent): void {
		if (event.code !== "Space") return;
		if (event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) return;

		const target = event.target as HTMLElement;
		const tagName = target.tagName?.toUpperCase();

		if (["INPUT", "TEXTAREA", "SELECT", "BUTTON", "A"].includes(tagName)) return;
		if (target.isContentEditable || target.closest('[contenteditable="true"]')) return;

		const role = target.getAttribute("role");
		if (role && ["textbox", "button", "link", "searchbox", "combobox"].includes(role)) return;

		if (target.closest("math-field, .ql-editor, .tox-edit-area")) return;

		event.preventDefault();
		this.showMenuPanel();
	}

	private subs: Subscription;

	constructor(
		private loginService: LoginService,
		private modalService: NgbModal,
		private imagePipe: ImagenPipe,
		private utils: Utils,
		public usersService: UsersService,
		private store: Store<State>,
		private eRef: ElementRef,
		private localStorage: LocalStorage,
		private mastersService: MastersService,
		private masterService: MastersService,
		private swUpdate: SwUpdate,
		private tutorialService: TutorialModalService,
		private route: ActivatedRoute,
		public router: Router,
		@Optional() private NbWindowRef: NbWindowRef
	) {
		this.user = this.loginService.getUser();
		//this.localStorage.setItem("TutorialesON", this.tutorialesActivos);
		this.tutorialesActivos = this.localStorage.getItem("TutorialesON") == 'true' ? true : false;
	}

	ngOnInit() {
		this.isMobile = window.innerWidth < 768;
		this.userSelectedProfile = this.loginService.getProfile();
		this.store
			.select((store) => store.profiles)
			.pipe(takeUntil(this.destroy$))
			.subscribe((profiles) => {
				this.profilesOfUser = profiles;
				this.applyPendingLastActivityIfReady();
			});
		this.loginService.currentProfile$
			.pipe(takeUntil(this.profileLifetime$))
			.subscribe(() => {
				this.actualProfile = this.loginService.getProfile();
			});

		// Nota: `justLoggedIn` se lee aquí pero se elimina solo después de procesar
		// la respuesta. Así, si el componente se destruye y remonta antes de que
		// llegue la respuesta del back (el side-bar fuerza `shouldReuseRoute=false`,
		// lo que provoca remounts frecuentes), el flag sigue disponible para reintentar.
		// La navegación al último ideógrafo la hace ahora `LoginComponent.navigateAfterLogin()`
		// directamente tras el login, así que aquí solo aplicamos el perfil correspondiente
		// y actualizamos `lastTarget*` en localStorage.
		const justLoggedIn = this.localStorage.getItem("justLoggedIn") === "true";

		const lastActivity$ = justLoggedIn
			? this.usersService.lastActivityUser()
			: this.usersService.getLastActivityCached(this.user?.idUser);

		lastActivity$.pipe(takeUntil(this.destroy$)).subscribe({
			next: (res) => {
				if (justLoggedIn) {
					this.localStorage.removeItem("justLoggedIn");
				}

				const role = res?.data?.role;
				const lastSelectedProfile = this.mapRoleToProfile(role);
				const idTarget = Number(res?.data?.idTarget) || 0;

				console.log('[UserAccount] lastActivityUser response:',
					{ role, mappedProfile: lastSelectedProfile, idTarget, justLoggedIn });

				// Aplicamos directamente el perfil en el LoginService (autoritativo).
				// Esto es idempotente con lo que ya hizo `LoginComponent.navigateAfterLogin`
				// para el flujo de login, y cubre el flujo de "remount del sidebar"
				// (shouldReuseRoute=false) y de cambio de URL sin re-login.
				if (lastSelectedProfile) {
					this.loginService.applyProfileFromActivityRole(role);
				}

				// Mantenemos el flujo del store de profiles para coordinar el modal
				// "actions" con `showActions=true` cuando aplica.
				this.pendingLastActivityProfile = lastSelectedProfile;
				this.pendingLastActivityJustLoggedIn = justLoggedIn;
				this.applyPendingLastActivityIfReady();

				if (idTarget > 0) {
					const roleUpper = (lastSelectedProfile || "").toUpperCase();
					if (roleUpper === this.profiles.Author || roleUpper === this.profiles.Editor) {
						localStorage.setItem("lastTarget_Editor", JSON.stringify(idTarget));
					} else {
						localStorage.setItem("lastTarget", JSON.stringify(idTarget));
					}
				}

				this.masterService.setIdTutorialContext(98);
				this.tutorialService.verTutoriales2$.pipe(takeUntil(this.destroy$)).subscribe(() => {
					this.tutorialesActivos =
						this.localStorage.getItem("TutorialesON") == "true" ? true : false;
				});
			},
			error: (err) => {
				console.warn('[UserAccount] Error en lastActivityUser, continuando con comportamiento por defecto:', err);
				if (justLoggedIn) {
					this.localStorage.removeItem("justLoggedIn");
				}

				this.masterService.setIdTutorialContext(98);
				this.tutorialService.verTutoriales2$.pipe(takeUntil(this.destroy$)).subscribe(() => {
					this.tutorialesActivos =
						this.localStorage.getItem("TutorialesON") == "true" ? true : false;
				});

				if (justLoggedIn) {
					this.firstStepStudent();
				}
			},
		});
		this.subs = this.usersService.initFirstStepStudent$.subscribe(() => {
			this.firstStepStudent();
		});
	}

	ngAfterViewInit() { }

	private mapRoleToProfile(role: string): string {
		// Delegamos al helper centralizado del LoginService. Si el rol no
		// se reconoce (vacío o desconocido) caemos a Estudiante para
		// preservar el comportamiento histórico de este componente.
		return this.loginService.mapRoleToProfile(role) ?? this.profiles.Student;
	}

	private applyPendingLastActivityIfReady(): void {
		if (!this.pendingLastActivityProfile || !this.hasProfilesLoaded()) {
			return;
		}
		this.applyProfileFromLastActivity(this.pendingLastActivityProfile, this.pendingLastActivityJustLoggedIn);
		this.pendingLastActivityProfile = null;
		this.pendingLastActivityJustLoggedIn = false;
	}

	private hasProfilesLoaded(): boolean {
		if (!this.profilesOfUser) {
			return false;
		}
		return [
			this.profilesOfUser.profileStudent,
			this.profilesOfUser.profileTeacher,
			this.profilesOfUser.profileEditor,
			this.profilesOfUser.profileParent,
			this.profilesOfUser.profileAdmin,
			this.profilesOfUser.profileCenter,
		].some(value => value === true);
	}

	private applyProfileFromLastActivity(profile: string, justLoggedIn: boolean): void {
		if (
			(profile == this.profiles.Editor || profile == this.profiles.Author) &&
			this.profilesOfUser.profileEditor == true
		) {
			this.setProfile(this.profiles.Author, justLoggedIn);
		} else if (
			profile == this.profiles.Teacher &&
			this.profilesOfUser.profileTeacher == true
		) {
			this.setProfile(this.profiles.Teacher, justLoggedIn);
		} else if (
			profile == this.profiles.Student &&
			this.profilesOfUser.profileStudent == true
		) {
			if (justLoggedIn) {
				this.firstStepStudent();
			} else if (this.loginService.getProfile() !== this.profiles.Student) {
				this.setProfile(this.profiles.Student, false);
			}
		} else if (
			profile == this.profiles.Admin &&
			this.profilesOfUser.profileAdmin == true
		) {
			this.showControlPanelAdmin();
		} else if (
			profile == this.profiles.Father &&
			this.profilesOfUser.profileParent == true
		) {
			this.showControlPanelParent();
		} else if (
			profile == this.profiles.Center &&
			this.profilesOfUser.profileCenter == true
		) {
			this.showControlPanel();
		}
	}

	@HostListener("window:resize", ["$event"])
	onResize(event: any): void {
		if (window.innerWidth <= 768) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnDestroy() {
		this.destroy$.next(true);
		this.destroy$.complete();
		this.profileLifetime$.next();
		this.profileLifetime$.complete();
		if (this.subs) {
			this.subs.unsubscribe();
		}
	}

	showMenuPanel() {
		if (!this.swUpdate.isEnabled) {

			this.openModal();
		} else {
			this.swUpdate.checkForUpdate().then((isUpdateAvailable) => {
				if (isUpdateAvailable) {
					if (
						confirm(
							"Nueva versión disponible. Es necesario actualizar ahora, si no, podrían haber errores en algunas funciones. ¿Actualizar ahora?"
						)
					) {
						window.location.reload();
					}
				}
			});
		}

		if (this.NbWindowRef) {
			this.NbWindowRef.close();
		}
		this.showUserAccount = !this.showUserAccount;
	}

	openModal() {
		// Obtener la versión más reciente desde el archivo ngsw.json
		fetch("/ngsw.json", { cache: "no-store" })
			.then((response) => response.json())
			.then((data) => {
				const latestVersion = data.assetGroups[0]?.version || "";

				// Obtener la versión guardada previamente en localStorage
				const currentVersion = localStorage.getItem("appVersion");

				// Si la versión guardada no existe, la guardamos por primera vez
				if (!currentVersion) {
					localStorage.setItem("appVersion", latestVersion);
					return;
				}

				// Si la versión ha cambiado, mostrar el mensaje de actualización
				if (currentVersion !== latestVersion) {
					if (confirm("Nueva versión disponible. ¿Deseas actualizar ahora?")) {
						window.location.reload();
					}
				}

				// Actualizar la versión en localStorage
				localStorage.setItem("appVersion", latestVersion);
			})
			.catch((err) => { })
	}

	setProfile(profile, showActions = true, navigateToLastTarget = false) {
		this.userSelectedProfile = profile;
		if (profile == this.profiles.Author || profile == this.profiles.Editor) {
			this.comeFromProfile = this.actualProfile;
		}
		if (
			profile == this.profiles.Teacher &&
			this.actualProfile == "ESTUDIANTE"
		) {
			localStorage.removeItem("selectedGroupInfo");
		}
		if (profile == this.profiles.Student && this.actualProfile == "PROFESOR") {
			localStorage.removeItem("selectedGroupInfo");
		}
		if (
			profile == this.profiles.Teacher &&
			this.comeFromProfile == "ESTUDIANTE"
		) {
			localStorage.removeItem("selectedGroupInfo");
		}
		if (
			profile == this.profiles.Student &&
			this.comeFromProfile == "PROFESOR"
		) {
			localStorage.removeItem("selectedGroupInfo");
		}
		localStorage.setItem("lastSelectedProfile", profile);
		this.loginService.setProfile(profile);
		this.usersService.updateLastActivityCacheRole(profile);

		if (navigateToLastTarget) {
			this.navigateToLastTargetForRole(profile);
		}
		if (showActions) {
			this.showModalProfileActions();
		}

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"cambio perfil",
			"El usuario ha activado el perfil " + profile + ".",
		);
		//*** Fin del log ***
	}

	private navigateToLastTargetForRole(profile: string): void {
		const role = (profile === this.profiles.Author || profile === this.profiles.Editor) ? 'EDITOR' : profile;
		this.usersService.lastTargetByRole(role).pipe(take(1)).subscribe(
			(res) => {
				const idCourse = Number(res?.data?.idCourse) || 0;
				const idTarget = Number(res?.data?.idTarget) || 0;
				if (idCourse > 0 && idTarget > 0) {
					this.router.navigate([`/course/${idCourse}/graph/${idTarget}`]);
				}
			},
			(err) => {
				console.warn('[UserAccount] Error fetching lastTargetByRole:', err);
			}
		);
	}

	firstStepStudent(fromProfileActions?: any) {
		if (fromProfileActions) {

			//this.localStorage.removeItem("selectedGroupInfo");
			this.enClase = true;
			this.enClaseScreen();
		} else {
			this.modalService.dismissAll();
			let dontLoadMenu = this.localStorage.getItem("dontLoadMenu");
			this.showUserAccount = false;
			this.userSelectedProfile = this.profiles.Student;
			this.localStorage.setItem("lastSelectedProfile", this.profiles.Student);
			this.loginService.setProfile(this.profiles.Student);
			this.usersService.updateLastActivityCacheRole(this.profiles.Student);
			this.navigateToLastTargetForRole(this.profiles.Student);
			const modalRef = this.modalService.open(ModalFirstStepStudentComponent, {
				scrollable: true,
				windowClass: `${MODAL_DIALOG_TYPES.W100} h-100`,
				backdrop: true,
				keyboard: true,
			});
			this.showUserAccount = false;
			this.destroy$.next(true);
			modalRef.result.then((result: any) => {
				if (result == "clase") {
					this.localStorage.setItem("enClase", 'true');
					this.enClase = true;
					this.enClaseScreen();
				} else if (result == "estudiando") {
					if (this.isMobile) {
						this.localStorage.setItem("showAvatarOnce", "true");
					}
					this.localStorage.removeItem("enClase");
					this.enClase = false;
					this.setProfile(this.profiles.Student);
				} else if (result == "") {
					return;
				}
			});
		}
	}

	enClaseScreen() {
		//cerramos el chat
		this.localStorage.removeItem("chatActive");
		const modalGrupos = this.modalService.open(ModalGruposEditarComponent, {
			scrollable: true,
			windowClass: this.loginService.esEstudiante() ? `${MODAL_DIALOG_TYPES.W100} h-100` : `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		//this.stopSocketToListenFroInstantActivity();
		//this.clearInterval()
		modalGrupos.result.then((result) => {
			this.setSelectedGroupInfo();
			if (result == 'close') {
				this.firstStepStudent();
				//si estamos como estudiante revisamos que no hayan pasado a lista en el grupo
				if (this.loginService.esEstudiante() && this.selectedGroupInfo) {
					//JAIME!!! ACUERDATE DE MIRAR ESTO!! LA ASISTENCIA ES IMPORTANTE
					//this.llamadoAsistencia();
					//this.fetchEventsProfesor([this.selectedGroupInfo?.idGroup]);
				}
				//this.handleSocketConnectionWhenGroupSelected();
				//this.startInterval();
			} else {
				this.setProfile(this.profiles.Student);
			}
		});
	}

	setSelectedGroupInfo() {
		let storedGroupInfo = JSON.parse(localStorage.getItem("selectedGroupInfo"));
		if (storedGroupInfo) {
			if (storedGroupInfo.idUser != this.user.idUser) {
				localStorage.removeItem("selectedGroupInfo");
			}
		}
		this.selectedGroupInfo = JSON.parse(
			localStorage.getItem("selectedGroupInfo")
		);
	}

	showGeneralSettings(): void {
		this.modalService.dismissAll();
		this.showUserAccount = false;
		let config = {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		};
		const modalRef = this.modalService.open(UserDataGeneralComponent, config);
		/**
		modalRef.result.then((result) => {
			if(result && this.isMobile){
				this.firstStepStudent();
			}
		});
		*/

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"ajustes generales",
			"El usuario con id " + this.user.idUser + " ha entrado en los Ajustes Generales.",
		);
		//*** Fin del log ***
	}

	getUserAvatar(): string {
		return this.utils.getUserAvatar(this.user.pictureUser);
	}

	logout(): void {
		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"logout",
			"El usuario con id " + this.user.idUser + " se ha deslogeado."
		);
		//*** Fin del log ***
		this.modalService.dismissAll();
		localStorage.removeItem("selectedGroupInfo");
		this.loginService.logout(true);
	}

	showModalProfileActions() {
		if (this.loginService.getProfile() === "CENTRO") {
			return; // No hacer nada para el perfil "CENTRO"
		}

		this.modalService.dismissAll();

		let modalClass;
		if (this.loginService.getProfile() === "PROFESOR") {
			modalClass = `${MODAL_DIALOG_TYPES.W90} h-100`;
		} else if (this.loginService.getProfile() === "ESTUDIANTE" && this.enClase) {
			modalClass = `${MODAL_DIALOG_TYPES.W100} h-100`;
		} else if (this.loginService.getProfile() === "ESTUDIANTE" && !this.enClase) {
			modalClass = `${MODAL_DIALOG_TYPES.W90} h-100`;
		} else {
			modalClass = MODAL_DIALOG_TYPES.W40;
		}

		const modalRef = this.modalService.open(ModalProfileActionsComponent, {
			scrollable: true,
			windowClass: modalClass,
		});

		modalRef.componentInstance.enClase = this.enClase;
		modalRef.result.then((result) => {
			if (result === "ESTUDIANTE") {
				this.firstStepStudent(this.enClase);
			} else {
				this.localStorage.removeItem("enClase");
			}
		});

		this.showUserAccount = false;
		this.destroy$.next(true);
	}

	//METODO AUXILIAR PARA SABER SI UN USUARIO FUE CREADO HACE MAS DE UNA SEMANA
	isMatureUser() {
		const fec_Create = this.user.fec_Create;
		const createDate = new Date(fec_Create);
		const currentDate = new Date();
		// Calculamos la diferencia en milisegundos
		const diffTime = currentDate.getTime() - createDate.getTime();
		// Una semana en milisegundos
		const oneWeek = 7 * 24 * 60 * 60 * 1000;
		let isMature = diffTime > oneWeek;

		return isMature;
	}

	sos() {
		this.modalService.open(MeetingsComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W80,
		});
		this.showUserAccount = false;
		this.destroy$.next(true);
	}

	showChatAssistant() {
		this.modalService.dismissAll();
		this.showUserAccount = false;
		this.destroy$.next(true);
		this.modalService.open(ChatAssistantComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W80,
		});
	}

	showControlPanel() {
		this.modalService.dismissAll();
		this.showUserAccount = false;

		this.navigateToLastTargetForRole(this.profiles.Center);
		this.modalService.open(ControlPanelComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});

		this.userSelectedProfile = this.profiles.Center;
		localStorage.setItem("lastSelectedProfile", this.profiles.Center);
		this.loginService.setProfile(this.profiles.Center);
		this.usersService.updateLastActivityCacheRole(this.profiles.Center);

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"mando de control",
			"El usuario con id " + this.user.idUser + " ha entrado en el mando de control."
		);
		//*** Fin del log ***
	}

	showControlPanelComercial() {
		this.modalService.dismissAll();
		this.showUserAccount = false;

		this.modalService.open(ControlPanelComercialComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});

		localStorage.setItem("lastSelectedProfile", this.profiles.Comercial);
		this.loginService.setProfile(this.profiles.Comercial);
		this.usersService.updateLastActivityCacheRole(this.profiles.Comercial);

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"mando de control",
			"Ha entrado en el mando de control de comercial."
		);
		//*** Fin del log ***
	}

	showControlPanelAdmin() {
		this.modalService.dismissAll();
		this.showUserAccount = false;

		this.navigateToLastTargetForRole(this.profiles.Admin);
		this.modalService.open(ControlPanelAdminComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});

		this.userSelectedProfile = this.profiles.Admin;
		localStorage.setItem("lastSelectedProfile", this.profiles.Admin);
		this.loginService.setProfile(this.profiles.Admin);
		this.usersService.updateLastActivityCacheRole(this.profiles.Admin);

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"mando de control",
			"Ha entrado en el mando de control de administrador."
		);
		//*** Fin del log ***
	}

	showControlPanelParent() {
		this.modalService.dismissAll();
		this.showUserAccount = false;

		this.navigateToLastTargetForRole(this.profiles.Father);
		this.modalService.open(ControlPanelPadresComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});

		this.userSelectedProfile = this.profiles.Father;
		localStorage.setItem("lastSelectedProfile", this.profiles.Father);
		this.loginService.setProfile(this.profiles.Father);
		this.usersService.updateLastActivityCacheRole(this.profiles.Father);

		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"mando de control padres",
			"Ha entrado en el mando de control de padres."
		);
		//*** Fin del log ***
	}

	onToggleTutorialChange() {
		//this.tutorialesActivos = this.localStorage.getItem("TutorialesON") != undefined ? this.localStorage.getItem("TutorialesON") == 'true' ? true : false : false;
		this.tutorialesActivos = !this.tutorialesActivos;
		this.localStorage.setItem("TutorialesON", this.tutorialesActivos);
		this.tutorialService.emitirVerTutoriales();
	}
}
